import { Box} from "@mui/material";
import Header from "../../../components/Header";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SecurityDataGrid from "../../../components/dataGridSecurity";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const InfrastructureLog = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [, setMaxCardHeight] = useState("1000px");
  const timezone = sessionStorage.getItem("timezone") || "Etc/GMT";
  const [payload, setPayload] = useState({
    dateFrom: dayjs().tz(timezone).subtract(1, "hour"),
    dateTo: dayjs().tz(timezone), 
    tipo: 5
  })


  useEffect(() => {
    const exact_detail = queryParams.get("exact_details");
    const detail = queryParams.get("details");
  
    if (exact_detail) {
      setPayload({
        ...payload,
        exact_detail: exact_detail ? exact_detail : '',
      });
    } else {
      setPayload({
        ...payload,
        detail: detail ? detail : '',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);




  useEffect(() => {
    const calcMaxHeight = () => {
      const screenHeight = window.innerHeight;
      const maxHeight = screenHeight - screenHeight * 0.22;
      setMaxCardHeight(`${maxHeight}px`);
    };
    calcMaxHeight();
    window.addEventListener("resize", calcMaxHeight);
    return () => window.removeEventListener("resize", calcMaxHeight);
  }, []);




  return (
    <Box m="20px">
      <Header
        title="Infrastructure Log"
        subtitle=""
        desc="Here are LOGs with details about network flows. These are very precise details of what is happening within the traffic and are very useful for checking connectivity problems. They can also be searched using the LIVE SEARCH BAR. They are useful, for example, in case of network problems at a specific time, to understand what happened in that specific time frame, thus highlighting the hosts that caused the problem. They, finally, can be Filtered or Exported"
      />
      <SecurityDataGrid tipo={5} tableKey="infra" passedPayload={payload}/>
    </Box>
  )
};

export default InfrastructureLog;
